"use client";
import { jsx } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { ColorGreen500 } from "@nxt-costco-com/forge-design-tokens";
import { useProductTileData } from "../../../hooks/useProductTileData/index.js";
import { AMOUNT_TOKEN } from "./constants.js";
function ReplaceAmount(displayString, amount) {
  if (!displayString || !amount) {
    return displayString;
  }
  return displayString.replace(AMOUNT_TOKEN, amount.toLocaleString());
}
function ExtraCartMessage({
  errorState,
  quantity
}) {
  var _a;
  const { translationsConfig } = useProductTileData();
  if (!quantity || quantity <= 0 || errorState) {
    return null;
  }
  if (!((_a = translationsConfig == null ? void 0 : translationsConfig.translations) == null ? void 0 : _a.redundentcartmessage)) {
    return null;
  }
  const displayString = ReplaceAmount(
    translationsConfig.translations.redundentcartmessage,
    quantity
  );
  return /* @__PURE__ */ jsx(Text, { variant: "t6", sx: { color: ColorGreen500, textAlign: "center" }, children: displayString });
}
export {
  ReplaceAmount,
  ExtraCartMessage as default
};
